import { toast } from 'sonner';

export async function downloadFile(url: string, filename: string) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error(error);
    toast.error('Failed to download file');
  }
}

export function scrollToBottom(element: HTMLElement | null, instant: boolean = false) {
  if (element) {
    // Create or find a scroll anchor at the bottom
    let scrollAnchor = element.querySelector('[data-scroll-anchor]') as HTMLElement;
    if (!scrollAnchor) {
      scrollAnchor = document.createElement('div');
      scrollAnchor.setAttribute('data-scroll-anchor', 'true');
      scrollAnchor.style.height = '1px';
      scrollAnchor.style.width = '1px';
      scrollAnchor.style.opacity = '0';
      scrollAnchor.style.pointerEvents = 'none';
      element.appendChild(scrollAnchor);
    }

    // Use scrollIntoView for smoother behavior
    const scrollOptions: ScrollIntoViewOptions = {
      behavior: instant ? 'instant' : 'smooth',
      block: 'end',
      inline: 'nearest',
    };

    setTimeout(
      () => {
        if (scrollAnchor) {
          scrollAnchor.scrollIntoView(scrollOptions);
        }
      },
      instant ? 0 : 16
    ); // Use 16ms for smoother animation frame timing
  }
}

export function scrollBottomToCenter(element: HTMLElement | null) {
  if (element) {
    const { scrollHeight, clientHeight } = element;
    // Calculate scroll position to put the last message more toward vertical center
    // Account for approximate message height by scrolling less
    const messageHeightOffset = 60; // Approximate height of a user message
    const targetScrollTop = scrollHeight - clientHeight / 2 - messageHeightOffset;

    element.scrollTo({
      top: Math.max(0, targetScrollTop), // Ensure we don't scroll to negative
      behavior: 'smooth',
    });
  }
}
